import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { jsx } from 'react/jsx-runtime';

const entityNameCard = EntityCardBlueprint.make({
  name: 'entity-name',
  params: {
    type: 'info',
    filter: entity =>
      entity.kind.toLowerCase() === 'servicegroup' ||
      (entity.kind.toLowerCase() === 'component' &&
        entity.spec?.type === 'service'),
    loader: () =>
      import('./EntityNameCard').then(m => jsx(m.EntityNameCard, {})),
  },
});

export const entityNameCardModule = createFrontendModule({
  pluginId: 'app',
  extensions: [entityNameCard],
});
